import { Container, Grid, Typography, Box, Stack, Button } from '@mui/material';
import React from 'react';

import Title from '../components/Title';
import { Fade } from 'react-awesome-reveal';
import Img1 from '../assets/images/section8/01.png';
import Img2 from '../assets/images/section8/02.png';
import Img3 from '../assets/images/section8/03.png';
import Img4 from '../assets/images/section8/04.png';
import Img5 from '../assets/images/section8/05.png';
import Img6 from '../assets/images/section8/06.png';

const cardData = [
  {
    src: Img1,
    title: 'dApps'
  },
  {
    src: Img2,
    title: 'Token Swaps'
  },
  {
    src: Img3,
    title: 'NFT Marketplace'
  },
  {
    src: Img4,
    title: 'Staking'
  },
  {
    src: Img5,
    title: 'Lottery'
  },
  {
    src: Img6,
    title: 'Gaming'
  }
];

const contentList = [
  {
    title: 'Taral Testnet',
    des: 'Revolutionizing Web3 wallet security with Taral Spirekey: Simplifying crypto management for everyone, ensuring a seamless, secure, and intuitive future.'
  },
  {
    title: 'Taral Assets Bridge',
    des: `Taral's Hyperlane integration enhances interoperability, offering staking, DeFi engagement, and cross-chain connections.`
  },
  {
    title: 'Taral ICO',
    des: 'Transforming Taral community experiences with enhanced security, privacy, and energy efficiency for Web3 in 2024.'
  }
];
const Section8 = () => {
  return (
    <Box sx={{ textAlign: 'center', color: 'white' }} component={Fade}>
      <Title
        style={{ textAlign: 'center', color: '#CA7729', fontSize: '35px', fontWeight: 'bold', letterSpacing: '0.02em' }}
        variant={{ xs: 'h3', md: 'h2' }}
        className="sectionHeadingTitle"
      >
        UPCOMING RELEASES
      </Title>
      <Container sx={{}}>
        <Grid container spacing={4} sx={{ mt: { xs: '10px', md: '0px' } }}>
          {contentList.map((item, i) => {
            return (
              <Grid item xs={12} sm={4} key={i}>
                <Box
                  style={{
                    background: '#f8edde',
                    // background: 'url(/images/homepage/cardbg.png)',
                    padding: '20px',
                    height: '100%',
                    borderRadius: '10px',
                    transition: 'opacity 0.3s',
                    '&:hover': {
                      opacity: '1',
                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
                    },
                    textAlign: 'left'
                  }}
                >
                  <Box sx={{ height: '86%' }}>
                    <Typography style={{ color: '#000000', fontWeight: 'bold' }} variant="h2" sx={{ mb: 2 }}>
                      {item?.title ? item?.title : ''}
                    </Typography>
                    <Typography
                      style={{ fontSize: '14px', color: '#000' }}
                      variant={{ xs: 'h4', sm: 'h3', md: 'h2' }}
                      sx={{ textAlign: 'left', letterSpacing: '0.05em', fontWeight: '500' }}
                    >
                      {item?.des ? item?.des : ''}
                    </Typography>
                  </Box>

                  <Button
                    variant="text"
                    style={{
                      backgroundColor: '#ffffff'
                    }}
                  >
                    <Typography style={{ p: 2, color: '#000', cursor: 'pointer', fontWeight: '500' }}>Learn More</Typography>
                  </Button>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
      <Container maxWidth="xl" sx={{ mt: 12 }}>
        <Box sx={{ mt: 10, mb: 18 }}>
          <Grid container spacing={10} flexWrap="wrap-reverse">
            {/* Left */}
            <Grid item xs={12} md={6}>
              <Stack style={{ textAlign: 'left' }}>
                <Typography variant="h1" sx={{ letterSpacing: '0.02em', mb: 1, fontSize: { xs: '20px', sm: '32px', lg: '58px' } }}>
                  EXPLORE THE{' '}
                </Typography>

                <Typography variant="h1" sx={{ letterSpacing: '0.02em', mb: 1, fontSize: { xs: '20px', sm: '32px', lg: '58px' } }}>
                  TARAL ECOSYSTEM
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: '500' }}>
                  Build your dApps, token swaps, NFT Marketplace, Staking, Lottery, Gaming, Casinos, and other Decentralized applications on
                  the Taral blockchain and benefit from its ecosystem of opportunities.
                </Typography>
              </Stack>

              <Box sx={{ display: 'flex', mt: 4 }}>
                <Button
                  variant="text"
                  style={{
                    backgroundColor: '#000000'
                  }}
                  sx={{ px: 2 }}
                >
                  <Typography style={{ padding: 2, color: 'white', fontWeight: '500' }}>Explore</Typography>
                </Button>
              </Box>
            </Grid>
            {/* Right */}
            <Grid container item xs={12} md={6} spacing={4}>
              {/* <Box component={'img'} width="100%" src="/images/card/cardimg.png" alt="cardimg" /> */}
              {cardData?.map((item, idx) => (
                <Grid container item xs={4} key={idx} sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <Box component={'img'} src={item.src} sx={{ width: '60px' }} />
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {item.title}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Section8;
